<template>
  <div
    class="input-wrapper"
    :class="{'input-wrapper_small': small , 'input-wrapper_error': isError }"
  >
    <Tooltip
      v-if="isExceedMin"
      class="alert"
      placement="top"
      :content="ErrorText"
    >
      <Icon type="md-alert"></Icon>
    </Tooltip>
    <div
      v-else
      class="handler"
    >
      <button
        class="btn"
        :class="{'btn_warning': isReachedMax}"
        :disabled="isReachedMax"
        @click="increase"
      >
        <Icon type="ios-arrow-up" />
      </button>
      <hr />
      <button
        class="btn"
        :class="{'btn_warning': isReachedMin}"
        :disabled="isReachedMin"
        @click="decrease"
      >
        <Icon type="ios-arrow-down" />
      </button>
    </div>
    <input
      :id="id"
      class="input"
      type="number"
      :min="min"
      :max="max"
      autocomplete="off"
      spellcheck="false"
      v-model="preparedModel"
      @keydown.stop="onkeyDown($event)"
      @input="onInput($event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    model: [String, Number],
    small: Boolean,
    min: { default: 0, type: Number },
    max: { default: Number.MAX_SAFE_INTEGER, type: Number },
    updateErrorCount: Function
  },
  data () {
    return {
      preparedModel: String(this.model)
    }
  },
  watch: {
    isError: function (value) {
      this.$emit('updateErrorCount', value)
    }
  },
  computed: {
    isError () {
      return (
        this.isExceedMax ||
        this.isExceedMin ||
        this.preparedModel === null
      )
    },
    isReachedMax () {
      return +this.preparedModel >= this.max
    },
    isReachedMin () {
      return +this.preparedModel <= this.min
    },
    isExceedMax () {
      return +this.preparedModel > this.max
    },
    isExceedMin () {
      return +this.preparedModel < this.min
    },
    ErrorText () {
      return `Минимальная сумма: ${this.min}`
    }
  },
  methods: {
    increase () {
      this.updateModel(+this.preparedModel + 1)
    },
    decrease () {
      this.updateModel(+this.preparedModel - 1)
    },
    onInput (e) {
      const currentValue = e.srcElement.value === '' ? null : +e.srcElement.value

      if (!currentValue && currentValue !== 0) {
        this.updateModel(null)
        return
      }

      if (currentValue > this.max) {
        this.updateModel(this.max)
        return
      }

      this.updateModel(currentValue)
    },
    updateModel (value) {
      this.preparedModel = value

      if (value && typeof this.model === 'string') {
        value = value.toString()
      }

      this.$nextTick(() => {
        this.$emit('update:model', value)
      })
    },
    onkeyDown (e) {
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss">
/* Drop out factory input[number] arrows */
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.input-wrapper {
  $input-radius: 4px;
  $border-color: #2a2f44;
  $text-color: white;
  $btn-color: #999;
  $handler-width: 22px;
  --input-wrapper-px: 8px;

  position: relative;
  width: 100%;
  height: 32px;
  color: $text-color;
  background-color: transparent;
  font-size: 16px;
  border: 1px solid $border-color;
  border-radius: $input-radius;
  transition: all 0.2s linear;

  .input {
    height: 100%;
    width: 100%;
    color: $text-color;
    background-color: transparent;
    padding-left: var(--input-wrapper-px);
    padding-right: $handler-width;
    border: none;
    outline: none;
  }

  .handler {
    position: absolute;
    width: $handler-width;
    height: 100%;
    font-size: 13px;
    line-height: 0;
    top: 0;
    right: 0;
    border-left: 1px solid $border-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s ease-in-out;
    opacity: 0;

    hr {
      width: 100%;
      border: 0;
      height: 1px;
      background-color: $border-color;
    }

    .btn {
      width: 100%;
      height: 100%;
      color: $btn-color;
      cursor: pointer;
      transition: color 0.2s ease;
      background: transparent;
      border: none;

      &:hover {
        color: $text-color;
      }

      &_warning {
        cursor: not-allowed;
        color:var(--color-danger-light);

        &:hover {
          color:var(--color-danger-light);
        }
      }
    }
  }

  .alert {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    padding: 0 var(--input-wrapper-px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: mediumvioletred;
    opacity: 0;
  }

  &_error {
    border: 1px solidvar(--color-danger-light);
  }

  &_small {
    width: 60px;
    height: 24px;
    --input-wrapper-px: 4px;

    .handler {
      font-size: 10px;
    }
  }

  &:focus-within,
  &:hover {
    border: 1px solid white;
  }

  &:hover {
    .handler {
      opacity: 1;
    }
  }

  &:not(:focus-within) {
    .alert {
      opacity: 1;
    }
  }
}
</style>
